<template>
    <ModalWrapper v-model="isShowModal">
        <template v-slot:title>
            {{ $t('change_manager') }}
        </template>
        <template v-slot:content>
            <v-radio-group v-model="propagateManagerToOldOrders">
                <v-radio
                    :label="$t('change_manager_for_all_reservations')"
                    :value="true"
                    data-cy="change-manager-for-all-reservations"
                />
                <v-radio
                    :label="$t('change_manager_for_new_reservations')"
                    :value="false"
                    data-cy="change-manager-for-new-reservations"
                />
            </v-radio-group>
        </template>
        <template v-slot:btns>
            <v-btn variant="flat" data-cy="save-contract" @click="saveContract">
                {{ $t('save') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script setup lang="ts">
    const propagateManagerToOldOrders = ref<boolean>(true)

    const isShowModal = defineModel<any>()

    const emit = defineEmits<{
        (e: 'onSave', value: boolean): void
    }>()

    const saveContract = () => {
        emit('onSave', propagateManagerToOldOrders.value)
        isShowModal.value = false
    }
</script>
